export default __webpack_public_path__ + "static/media/AuthBG.235c4b1d.jpg";